export default __webpack_public_path__ + "static/media/no-projects.31285e25.png";